import { Check, X } from 'lucide-react';

const features = [
  { name: 'Bulk Messaging', starter: true, pro: true, enterprise: true },
  { name: 'Contact Management', starter: true, pro: true, enterprise: true },
  { name: 'Basic Analytics', starter: true, pro: true, enterprise: true },
  { name: 'Email Support', starter: true, pro: true, enterprise: true },
  { name: 'Advanced Analytics', starter: false, pro: true, enterprise: true },
  { name: 'Automation & Chatbots', starter: false, pro: true, enterprise: true },
  { name: 'API Access', starter: false, pro: true, enterprise: true },
  { name: 'Team Collaboration', starter: false, pro: true, enterprise: true },
  { name: 'Priority Support', starter: false, pro: true, enterprise: true },
  { name: 'White-label Solution', starter: false, pro: false, enterprise: true },
  { name: 'Custom Integrations', starter: false, pro: false, enterprise: true },
  { name: 'Dedicated Account Manager', starter: false, pro: false, enterprise: true },
  { name: 'SLA Guarantee', starter: false, pro: false, enterprise: true },
];

export function ComparisonTable() {
  return (
    <div className="bg-white py-20 px-4" data-testid="comparison-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Compare plans
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Detailed feature comparison across all plans
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-gray-200">
                <th className="text-left py-4 px-6 text-gray-900 font-semibold">Feature</th>
                <th className="text-center py-4 px-6 text-gray-900 font-semibold">Starter</th>
                <th className="text-center py-4 px-6 text-gray-900 font-semibold bg-[#E8F9EE]">Professional</th>
                <th className="text-center py-4 px-6 text-gray-900 font-semibold">Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => (
                <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="py-4 px-6 text-gray-700">{feature.name}</td>
                  <td className="py-4 px-6 text-center">
                    {feature.starter ? (
                      <Check className="w-5 h-5 text-[#00D95F] mx-auto" />
                    ) : (
                      <X className="w-5 h-5 text-gray-300 mx-auto" />
                    )}
                  </td>
                  <td className="py-4 px-6 text-center bg-[#E8F9EE]">
                    {feature.pro ? (
                      <Check className="w-5 h-5 text-[#00D95F] mx-auto" />
                    ) : (
                      <X className="w-5 h-5 text-gray-300 mx-auto" />
                    )}
                  </td>
                  <td className="py-4 px-6 text-center">
                    {feature.enterprise ? (
                      <Check className="w-5 h-5 text-[#00D95F] mx-auto" />
                    ) : (
                      <X className="w-5 h-5 text-gray-300 mx-auto" />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
